import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';


@Component({
  selector: 'accessory-detail',
  templateUrl: './accessory-detail.component.html',
  styleUrls: ['./accessory-detail.component.scss'],
})
export class AccessoryDetailComponent implements OnInit {

  @Input() data : {};
  values = {};

  constructor(private modalController: ModalController) {
  }

  ngOnInit(){
    this.values['img'] = this.data['product'].gridImage;
    this.values['productNmane'] = this.data['product'].name;
    this.values['values'] = [];

    this.data['labelTecnicalData'].forEach(orderedKeys => {

      if (orderedKeys.label.toLowerCase() == 'p/n') {
        this.values['values'].push({
          label : 'p/n',
          value : [this.data['product'].pn]
        });
      } else {

        if (Object.keys(this.data['keys']).includes(orderedKeys.label.toLowerCase())) {
          let value = '';
          this.data['product'].technicalData.forEach(item => {
            if (item.technicalDataLabel.toLowerCase() == orderedKeys.label.toLowerCase()) {
              value = item.techDataSpecification;
            }
          });
          this.values['values'].push({
            label : orderedKeys.label,
            value : [value]
          });
        } else {

          const veryLabel = orderedKeys.label.substring(0,orderedKeys.label.lastIndexOf(' '))
          const checkedKey = this.values['values'].find(item => {
            if (item.label.toLowerCase() == veryLabel.toLowerCase()) {
              return true;
            }
          });
          if (checkedKey == undefined) {
            const data = [];
            this.data['keys'][veryLabel].forEach(measure =>{
              const newValue = veryLabel + ' ' + measure;
                  this.data['product'].technicalData.forEach(item => {
                    if (item.technicalDataLabel.toLowerCase() == newValue.toLowerCase()) {
                      data.push(item.techDataSpecification + measure);
                    }
                  });
            });

            this.values['values'].push({
              label : veryLabel,
              value : data
            });
          }
        }
      }
    });
  }

  dismiss() {
    this.modalController.dismiss();
  }
}
